import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CriticalAlertsCenter = ({ alerts, onRecoveryAction }) => {
  const getSeverityConfig = (severity) => {
    switch (severity) {
      case 'high':
        return {
          icon: 'AlertCircle',
          bgColor: 'bg-error/10',
          borderColor: 'border-error/20',
          textColor: 'text-error',
          iconColor: 'var(--color-error)'
        };
      case 'medium':
        return {
          icon: 'AlertTriangle',
          bgColor: 'bg-warning/10',
          borderColor: 'border-warning/20',
          textColor: 'text-warning',
          iconColor: 'var(--color-warning)'
        };
      case 'low':
        return {
          icon: 'Info',
          bgColor: 'bg-primary/10',
          borderColor: 'border-primary/20',
          textColor: 'text-primary',
          iconColor: 'var(--color-primary)'
        };
      default:
        return {
          icon: 'AlertCircle',
          bgColor: 'bg-muted/30',
          borderColor: 'border-border',
          textColor: 'text-muted-foreground',
          iconColor: 'var(--color-muted-foreground)'
        };
    }
  };

  const getRecoveryButtonText = (action) => {
    switch (action) {
      case 'reconnect-ml':
        return 'Reconectar ML';
      case 'configure-shopee':
        return 'Configurar Shopee';
      case 'test-openai':
        return 'Testar OpenAI';
      case 'clear-queue':
        return 'Limpar Fila';
      default:
        return 'Resolver';
    }
  };

  if (!alerts || alerts?.length === 0) {
    return (
      <div className="bg-success/10 border border-success/20 rounded-lg p-6">
        <div className="flex items-center gap-3">
          <Icon name="CheckCircle2" size={24} color="var(--color-success)" />
          <div>
            <h3 className="font-semibold text-success">Sistema Operacional</h3>
            <p className="text-sm text-success/80">Nenhum alerta crítico detectado</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-4">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-error/10">
          <Icon name="AlertCircle" size={24} color="var(--color-error)" />
        </div>
        <div>
          <h3 className="font-semibold text-foreground">Alertas Críticos</h3>
          <p className="text-xs text-muted-foreground">
            {alerts?.length} {alerts?.length === 1 ? 'problema requer' : 'problemas requerem'} atenção
          </p>
        </div>
      </div>

      <div className="space-y-3">
        {alerts?.map((alert) => {
          const config = getSeverityConfig(alert?.severity);

          return (
            <div 
              key={alert?.id}
              className={`p-4 rounded-lg border ${config?.bgColor} ${config?.borderColor} space-y-3`}
            >
              <div className="flex items-start gap-3">
                <Icon name={config?.icon} size={20} color={config?.iconColor} />
                <div className="flex-1">
                  <h4 className={`font-semibold ${config?.textColor} mb-1`}>
                    {alert?.title}
                  </h4>
                  <p className="text-sm text-muted-foreground">
                    {alert?.message}
                  </p>
                  <p className="text-xs text-muted-foreground mt-2">
                    {new Date(alert?.timestamp)?.toLocaleString('pt-BR')}
                  </p>
                </div>
              </div>

              {alert?.recoveryAction && (
                <Button
                  variant="outline"
                  iconName="Wrench"
                  iconPosition="left"
                  onClick={() => onRecoveryAction?.(alert?.recoveryAction)}
                  size="sm"
                >
                  {getRecoveryButtonText(alert?.recoveryAction)}
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CriticalAlertsCenter;